var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_618_57500)","key":0},[React.createElement("path",{"d":"M7.99967 14.6673C11.6816 14.6673 14.6663 11.6825 14.6663 8.00065C14.6663 4.31875 11.6816 1.33398 7.99967 1.33398C4.31778 1.33398 1.33301 4.31875 1.33301 8.00065C1.33301 11.6825 4.31778 14.6673 7.99967 14.6673Z","stroke":"#333333","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M8 4V8L10.6667 9.33333","stroke":"#333333","strokeLinecap":"round","strokeLinejoin":"round","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_618_57500"},React.createElement("rect",{"width":"16","height":"16","fill":"white"})))]);
}

Clock.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Clock;

Clock.default = Clock;
